import { fetchData, postData } from "./apis";

const path = "/manufacturing";

export const manufacturingVouchersApi = (value) => {
  let endPoint = `${path}/manufacturing-vouchers`;
  return postData(endPoint, value);
};

export const manufacturingDeleteApi = (value) => {
  let endPoint = `${path}/manufacturing-delete`;
  return postData(endPoint, value);
};

export const manufacturingRecordWithDetailseApi = (value) => {
  let endPoint = `${path}/get-manufacturing-record-with-details`;
  return postData(endPoint, value);
};

export const manufacturingVoucherNumbereApi = (val) => {
  let endPoint = `${path}/get-manufacturing-voucher-no`;
  return postData(endPoint, val);
};
